export default __webpack_public_path__ + "static/media/arrow-left-black.ae5da00d.svg";